import { RouteList } from "Routes";
import { RulesSettings } from "commands/frankenstories/RulesSettings";
import { useCallback } from "react";
import { DeepPartialSkipArrayKey } from "react-hook-form";
import { useHistory } from "react-router-dom";

export const importSettingsLocalStorageKey = "import-settings";

export type DuplicationItem = DeepPartialSkipArrayKey<RulesSettings & { imageUrl: string }>;

export const useDuplication = () => {
    const history = useHistory();

    const exportSettings = useCallback(
        (settings: DuplicationItem, destination: string = RouteList.GamesNewGame) => {
            const settingsString = JSON.stringify(settings);
            localStorage.setItem(importSettingsLocalStorageKey, settingsString);

            history.push(destination);
        },
        [history],
    );

    const getSettings = useCallback(() => {
        const settingsString = localStorage.getItem(importSettingsLocalStorageKey);

        if (settingsString) {
            const settings = JSON.parse(settingsString) as DuplicationItem;

            localStorage.removeItem(importSettingsLocalStorageKey);

            return settings;
        }

        return null;
    }, []);

    return {
        exportSettings,
        getSettings,
    };
};
